import { Component, ViewEncapsulation, Input } from '@angular/core';
import { TIconType } from '../../icon/icon.types';

@Component({
	selector: '[rbc-link-card]',
	templateUrl: './link-card.component.html',
	styleUrls: ['./link-card.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class LinkCardComponent {
	@Input() columns: string;
	@Input() icon: string;
	@Input() iconWeight: TIconType = 'regular';
	@Input() layout: string = 'card';
	@Input() link: string;
	@Input() marker: string;
	@Input() smallText: string;
	@Input() target: string;
	@Input() title: string;

	constructor() {}
}
